import React, { Component } from 'react';
import EnhancedTable from '../../components/dataTableCountry'
import { Card, CardHeader, CardBody } from 'reactstrap'
import exportlistImg from '../../../src/assets/fontawesome/csv.png'
import AppContext from '../../AppContext'
import ClipLoader from 'react-spinners/ClipLoader'
import Modal from 'react-modal'
import { Helmet } from "react-helmet";
import LazyLoad from 'react-lazyload'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '350px',
    height: '200px',
    border: 0,
    padding: 33,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};
Modal.setAppElement('#root')

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      country: props.match.params.country,
      page: 1
    };
  }
  selectCompany = (company, id) => {

    this.props.history.push(`/company/${company}`);
  }

  download = () => {
    this.setState({ modalIsOpen: true })
    this.props.history.push('/export_list')
  }
  openModal = () => {
    this.setState({ modalIsOpen: true });
  }
  componentDidMount() {
    const { country } = this.props.match.params
    this.setState({ country })

  }

  componentWillReceiveProps(nextprops) {
    const { country } = nextprops.match.params
    this.setState({ country })
  }

  afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    //this.subtitle.style.color = '#f00';
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }
  render() {
    var { country } = this.state
    if (country === 'UK') country = 'United Kingdom'
    var header = ''
    var title = ''
    header = `Fastest Growing Companies in ${country}`
    title = `Fastest Growing Companies in ${country}: Growjo`
    const tableData = this.context ? this.context : {}

    return (
      <div className="animated fadeIn" style={{ height: "100%" }}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={title} />
          <meta name="author" content="Growjo" />
        </Helmet>
        <Card style={{ height: '100%', marginBottom: 0 }}>
          <CardHeader style={{ backgroundColor: 'white' }}>
            <div>
              <span style={{ color: '#474866', fontSize: 21, fontWeight: 'bold' }}>Growjo 1,000</span><br />
              <span style={{ color: '#a9abb8', fontSize: 15 }}>{header}</span>
            </div>
            <div className='download' onClick={this.download}>
              <span>Free Download</span>
              <LazyLoad>
                <img src={exportlistImg} />
              </LazyLoad>
            </div>
          </CardHeader>
          <CardBody><EnhancedTable tableData={tableData} /></CardBody>
        </Card>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          shouldFocusAfterRender={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={true}
        >
          <div style={{ backgroundColor: "white", fontSize: 15, textAlign: "center" }}>
            <h5>While your file is downloading...</h5>
            <span>Please check us out on <a href="https://www.producthunt.com/posts/growjo" target="_blank">Product Hunt</a></span>
            <div style={{ display: "block", marginTop: 28 }}>
              <ClipLoader
                sizeUnit={"px"}
                size={40}
                color={'grey'}
                loading={this.state.downloading}
                display={'block'}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
Home.contextType = AppContext;
export default Home;





// WEBPACK FOOTER //
// ./client/src/views/Home/country.js